import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'select-all-btn',
    colSize: '6',
    active: false,
    col: 'select-btn'
  },
  {
    title: 'Year',
    colSize: '5',
    sortable: true,
    sort: 'desc',
    col: 'year',
    columnName: 'year',
  },
  {
    title: 'Make',
    colSize: '7',
    sortable: true,
    sortName: 'make',
    sort: 'desc',
    active: false,
    col: 'make',
    columnName: 'make',
  },
  {
    title: 'Model',
    colSize: '17',
    sortable: true,
    sortName: 'model',
    sort: 'desc',
    active: false,
    col: 'model',
    columnName: 'model',
  }
];
